import { z, type infer as zInfer } from "zod";
import { timestamp } from "@/hooks/firestore/v2/models/timestamp";
import { promotionCampaign } from "@/hooks/firestore/v2/models/promotionCampaign";
import { racingEventStatusEnum } from "@/hooks/firestore/v2/models/racingEvent";

const raceMeeting = z.object({
  date: z.string(),
  scheduledStartTime: z.string(),
  scheduledStartTimeTs: timestamp,
  sport: z.enum(["HORSE_RACING", "GREYHOUNDS", "HARNESS_RACING"]),
  venue: z.string(),
  venueId: z.string(),
  eventCount: z.number(),
  country: z.string(),
  state: z.string().optional(),
  trackCondition: z.string().optional(),
  trackRating: z.string().optional(),
  trackType: z.string().optional(),
  weather: z.string().optional(),
  rail: z.string().optional(),
  region: z.enum(["ANZ", "ROW"]),
  currentRace: z.object({
    id: z.string(),
    name: z.string(),
    number: z.number(),
    surface: z.string().optional(),
    scheduledStartTime: z.string(),
    scheduledStartTimeTs: timestamp,
    status: racingEventStatusEnum,
    trackCondition: z.string().optional(),
    hasPromotionalMarkets: z.boolean(),
    promotionCampaigns: z.array(promotionCampaign).nullish(),
  }),
  hasPromotionalMarkets: z.boolean(),
  promotionCampaigns: z.array(promotionCampaign).nullish(),
  filters: z.array(z.string()),
  visible: z.boolean(),
});

export type RaceMeeting = zInfer<typeof raceMeeting>;

export { raceMeeting };
